import { render, staticRenderFns } from "./configScreen.vue?vue&type=template&id=6edc09f2&"
import script from "./configScreen.vue?vue&type=script&lang=js&"
export * from "./configScreen.vue?vue&type=script&lang=js&"
import style0 from "./configScreen.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports